export var IStatWidgetType;
(function (IStatWidgetType) {
    IStatWidgetType["Lines"] = "lines";
    IStatWidgetType["Bars"] = "bars";
    IStatWidgetType["Table"] = "table";
    IStatWidgetType["Chart"] = "chart";
})(IStatWidgetType || (IStatWidgetType = {}));
export var IOperationType;
(function (IOperationType) {
    IOperationType["Difference"] = "difference";
    IOperationType["Summation"] = "summation";
})(IOperationType || (IOperationType = {}));
